import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UserModel } from '../../shared/models/user.model';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: object, private router: Router) { }

  public set token(token: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('token', token);
    }
  }

  public get token(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('token') || '';
    }
    return '';
  }

  public set userData(data: UserModel) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('userData', JSON.stringify(data));
    }
  }

  public get userData(): UserModel {
    if (isPlatformBrowser(this.platformId)) {
      const raw = localStorage.getItem('userData');
      if (!raw) {
        return {} as UserModel;
      }
      try {
        return JSON.parse(raw) as UserModel;
      } catch {
        return {} as UserModel;
      }
    }
    return {} as UserModel;
  }

  public removeToken(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
  }
  public logout(): void {
    this.removeToken();
    this.router.navigate(['/auth/login']);
  }
}
